<template ref="rolecollapse">
    <el-collapse accordion>
        <div v-for="(item, index) in list" :key="index">
            <!-- 资源名称 -->
            <el-row>
                <el-col :span="1">
                    <td-checkbox
                        style="line-height:50px;"
                        v-model="item.checkAll"
                        :sParentId="item.sParentId"
                        :ref="item.resId"
                        @change="
                            val => {
                                handleCheckAllChange(val, index, item);
                            }
                        "
                    ></td-checkbox>
                </el-col>
                <el-col :span="23">
                    <el-collapse-item :title="item.resName" :name="item">
                        <!-- 权限复选框 -->
                        <td-checkbox-group
                            v-if="item.authTypes"
                            :allList="item.authTypes"
                            v-model="item.checkList"
                            keys="authId"
                            text="authName"
                            @handleCheckedChange="
                                val => {
                                    handleCheckedGroupChange(val, item);
                                }
                            "
                        ></td-checkbox-group>
                        <tree-collapse
                            :formRoleInfo="formRoleInfo"
                            :list="item.children"
                            :isAddData="isAddData"
                            @sendCheckList="handleCheckedGroupChange"
                            @sendCheckAllChange="handleCheckAllChange"
                            @setCheckAllBtnStatus="setCheckAllBtnStatus"
                            @checkAllChange="checkAllChange"
                            style="padding: 0 0 0 20px;"
                        ></tree-collapse>
                    </el-collapse-item>
                </el-col>
            </el-row>
        </div>
    </el-collapse>
</template>

<script>
import resourceApi from '../assets/api.js';
export default {
    props: ['list', 'listAll', 'formRoleInfo', 'isAddData'],
    name: 'tree-collapse',
    // 定义变量
    created() {
        //console.log(this.list);
    },
    data() {
        return {
            that: this,
            allList: [],
            checkList: [],
            pageInit: true,
            resInitList: [],
            returnList: []
        };
    },
    watch: {
        /* 监听数据的变化，实时生效 */
        list: {
            handler: function(newVal) {
                this.list = newVal;
            },
            deep: true
        }
    },
    methods: {
        //废弃
        getCheckedAuth(data) {
            this.$emit('getCheckedAuth', data);
            this.formRoleInfo.resId = data.resId;
            if (this.resInitList.indexOf(this.formRoleInfo.resId) === -1) {
                this.resInitList.push(this.formRoleInfo.resId);
                this.pageInit = true;
            } else {
                this.pageInit = false;
            }
            if (this.pageInit && !this.isAddData) {
                let checkAuth = [];
                resourceApi.listRoleResAuth(JSON.stringify(this.formRoleInfo), response => {
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('/auth/role/getCheckedAuth', response.data.statusMessage);
                        return;
                    }
                    checkAuth = response.data.content;
                    // 初始化默认选中状态
                    for (let i = 0; i < checkAuth.length; i++) {
                        let checkObj = {};
                        checkObj = checkAuth[i].resId + ',' + checkAuth[i].authId;

                        this.checkList.push(checkObj);
                    }
                });
            }
        },
        //全选反选
        handleCheckAllChange(val, index, data) {
            this.$emit('sendCheckAllChange', val, index, data);
        },
        getAllSelectedItems() {},
        handleCheckedGroupChange(val, data) {
            data.checkList = new Array();
            for (let i = 0; i < val.length; i++) {
                data.checkList.push(val[i]);
            }
            this.$emit('sendCheckList', val, data);
            this.$emit('setCheckAllBtnStatus', val, data);
        }
    }
};
</script>
